































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
@Component({})
export default class Upload extends Vue {
  @Prop({ type: Function, required: true }) handleConfirm: any;
  @Prop(Boolean) isSchoolLogo: any;
  private dialogImageUrl = '';
  private dialogVisible = false;
  private showAddIcon = true;
  private imgUrl = '';
  private action = `${process.env.VUE_APP_API}/mate/uploadMaterial/`;
  private visible = false;

  private handleRemove(file: any, fileList: any) {
    this.showAddIcon = true;
    this.imgUrl = '';
  }
  private handlePictureCardPreview(file: any) {
    this.dialogImageUrl = file.url;
    this.dialogVisible = true;
  }
  private handleExceed(files: any, fileList: any) {
    this.$message.warning(
      `当前限制选择 1 个文件，本次选择了 ${
        files.length
      } 个文件，共选择了 ${files.length + fileList.length} 个文件`
    );
  }
  private beforeAvatarUpload(file: any) {
    const imgType =
      file.type === 'image/jpg' ||
      file.type === 'image/png' ||
      file.type === 'image/jpeg';
    const isLt2M = file.size / 1024 / 1024 < 100;

    if (!imgType) {
      this.$message.error('上传头像图片只能是 JPG, JPEG, PNG 格式!');
    }
    if (!isLt2M) {
      this.$message.error('上传头像图片大小不能超过 100MB!');
    }
    return imgType && isLt2M;
  }
  private onSuccess(response: any, file: any, fileList: any) {
    if (response.data) {
      this.showAddIcon = false;
      this.imgUrl = response.data;
    }
  }
  private onCancel() {
    (this.$refs.upload as any).clearFiles();
    this.visible = false;
    this.imgUrl = '';
    this.showAddIcon = true;
  }
  private handleSuccess() {
    if (!this.imgUrl) {
      this.$message.error('请上传图片!');
      return;
    }
    // reset
    (this.$refs.upload as any).clearFiles();
    this.handleConfirm(this.imgUrl);
    this.visible = false;
    this.imgUrl = '';
    this.showAddIcon = true;
  }
  private onError() {
    this.$message.error('上传头失败!');
  }
}
